export default __webpack_public_path__ + "static/media/geofence.0dab0bca.jpeg";